import { IDetailState } from "./interfaces";

export const DEFAULT_DETAIL_STATE: IDetailState = {
	source: "",
	id: 0,
	loading: false,
	status: 0,
	data: null,
	mark: null,
	centerZoom: {
		lon: 0,
		lat: 0,
		zoom: 0,
		bbox: [[0, 0], [0, 0]],
		geomBbox: null,
	},
};
